import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid';

/**
 * Material Cell Renderer for Summary Material Grid
 *
 * Displays material code and name in a formatted layout:
 * - Code on first line (smaller, gray text)
 * - Name on second line (normal text)
 */
@Component({
  selector: 'app-material-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col py-2">
      <span class="text-xs text-gray-500 dark:text-gray-400 font-mono">
        {{ params?.data?.code ?? '-' }}
      </span>
      <span class="text-sm">
        {{ params?.data?.name ?? '-' }}
      </span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class MaterialCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;
}
